module.exports = __webpack_public_path__ + "static/media/consultingSchema.788fcd00.svg";